import { type PayloadAction, createSlice } from "@reduxjs/toolkit";

import {
  ModalGameCenterTabs,
  ModalTypes,
  ModalGameEditTabs,
} from "configs/types";

export const MIRROR_PRIORITIES = ['low', 'medium', 'high'];


interface ModalsState {
  activeModal?: ModalTypes;
  activeModalTab?: ModalGameCenterTabs | ModalGameEditTabs;
  addGameModalType?: "tag" | "collection";
}

const initialState: ModalsState = {};

export const modalsSlice = createSlice({
  name: "modals",
  initialState,
  reducers: {
    openModal: (state: ModalsState, action: PayloadAction<ModalsState>) => {
      state.activeModal = action.payload.activeModal;
      state.activeModalTab = action.payload.activeModalTab;
      state.addGameModalType = action.payload.addGameModalType;
    },
    closeModal: (state: ModalsState) => {
      state.activeModal = undefined;
      state.activeModalTab = undefined;
      state.addGameModalType = undefined;
    },
  },
});

export const { openModal, closeModal } = modalsSlice.actions;
